const validate = (values) => {
    let errors = {};
    if (values.testYo) {
        errors.test = "test";
    }
    return errors;
};

export default validate;
